module.exports = __webpack_public_path__ + "img/husky-farm.092420ca.webp";